module.exports = __webpack_public_path__ + "static/media/forms-hero.44646e40.jpg";